module.exports = __webpack_public_path__ + "img/folder-bookmark.f87206bd.svg";